import React, {Component} from 'react';
import BiletyMiesieczneService from "./BiletyMiesieczneService";
import {Button, ControlLabel, Form, FormControl, FormGroup} from "react-bootstrap";
import {NotificationManager} from "react-notifications";

export default class FirmyForm extends Component {

    constructor(props) {

        super(props);
        this.state = {

            nazwa: '',
            nip: '',
            regon: '',
            miejscowosc: '',
            kodPocztowy: '',
            ulica: '',
            budynek: '',
            lokal: '',
            wojewodztwo: '',
            powiat: '',
            gmina: '',
            poczta: '',
            formaPrawna: '',
            formaSzczegolowaNazwa: '',
            idFi: 0,

            validatorMessages: [],

            czyKliknietoWyszukaj: false,
            czyZnaleziono: false
        };

        this.onClickZapisz = this.onClickZapisz.bind(this);
        this.onChangeWartosc = this.onChangeWartosc.bind(this);
        this.onClickWyszukaj = this.onClickWyszukaj.bind(this);

    }

    componentDidMount() {
        this.ustawDoEdycji(this.props.edytowanaFirma)
    }

    componentWillReceiveProps(nextprops) {
        this.ustawDoEdycji(nextprops.edytowanaFirma)
    }

    ustawDoEdycji(firma, czyWyszukanoNip = false) {

        if (Boolean(firma)) {

            if (!czyWyszukanoNip) {
                document.getElementById('inputNip').value = firma.nip;
                this.setState({
                    nip: firma.nip
                })
            }

            this.setState({
                nazwa: firma.nazwa,
                regon: firma.regon,
                miejscowosc: firma.miejscowosc,
                kodPocztowy: firma.kodPocztowy,
                ulica: firma.ulica,
                budynek: (czyWyszukanoNip) ? firma.numerNieruchomosci : firma.nrNieruchomosci,
                lokal: (czyWyszukanoNip) ? firma.numerLokalu : firma.nrLokalu,
                wojewodztwo: firma.wojewodztwo,
                powiat: firma.powiat,
                gmina: firma.gmina,
                poczta: firma.poczta,
                formaPrawna: (czyWyszukanoNip) ? firma.formaPodstawowaNazwa : firma.formaPrawna,
                formaSzczegolowaNazwa: firma.formaSzczegolowaNazwa,
                idFi: (this.props.edytowanaFirma && !czyWyszukanoNip) ? firma.idFi : 0,
            });

            document.getElementById('inputNazwa').value = firma.nazwa;
            document.getElementById('inputRegon').value = firma.regon;
            document.getElementById('inputMiejscowosc').value = firma.miejscowosc;
            document.getElementById('inputKodPocztowy').value = firma.kodPocztowy;
            document.getElementById('inputUlica').value = firma.ulica;
            document.getElementById('inputNrNieruchomosci').value = (czyWyszukanoNip) ? firma.numerNieruchomosci : firma.nrNieruchomosci;
            document.getElementById('inputNrLokalu').value = (czyWyszukanoNip) ? firma.numerLokalu : firma.nrLokalu;
            document.getElementById('inputWojewodztwo').value = firma.wojewodztwo;
            document.getElementById('inputPowiat').value = firma.powiat;
            document.getElementById('inputGmina').value = firma.gmina;
            document.getElementById('inputPoczta').value = firma.poczta;
            document.getElementById('inputformaPrawna').value = (czyWyszukanoNip) ? firma.formaPodstawowaNazwa : firma.formaPrawna;
            document.getElementById('inputformaSzczegolowaNazwa').value = firma.formaSzczegolowaNazwa
        }
    }

    onChangeWartosc(e, key) {
        this.state[key] = e.target.value;

        if (key === 'nip') {
            this.setState({
                czyKliknietoWyszukaj: false,
                czyZnaleziono: false
            })
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg);
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        let poprawne = true;

        if (!Boolean(this.state.nazwa)) {
            poprawne = false;
            NotificationManager.error("", "Należy uzupełnić nazwę firmy ", 5000);
        }
        if (!Boolean(this.state.nip)) {
            poprawne = false;
            NotificationManager.error("", "Należy uzupełnić NIP firmy ", 5000);
        }
        if (!Boolean(this.state.miejscowosc)) {
            poprawne = false;
            NotificationManager.error("", "Należy uzupełnić miejscowość ", 5000);
        }

        if (poprawne) {
            let data = {
                "formaPrawna": this.state.formaPrawna,
                "formaSzczegolowaNazwa": this.state.formaSzczegolowaNazwa,
                "gmina": this.state.gmina,
                "idFi": this.state.idFi,
                "kodPocztowy": this.state.kodPocztowy,
                "miejscowosc": this.state.miejscowosc,
                "nazwa": this.state.nazwa,
                "nip": this.state.nip,
                "nrLokalu": this.state.lokal,
                "nrNieruchomosci": this.state.budynek,
                "poczta": this.state.poczta,
                "powiat": this.state.powiat,
                "regon": this.state.regon,
                "ulica": this.state.ulica,
                "wojewodztwo": this.state.wojewodztwo
            };

            this.props.handleClickZapisz(data, Boolean(this.props.edytowanaFirma))
        }
    }

    onClickWyszukaj() {
        if (this.state.nip.length >= 10) {
            BiletyMiesieczneService.szukajFirmePoNipie(this.state.nip).then(function (response) {
                if (response.data) {
                    this.setState({czyKliknietoWyszukaj: true, czyZnaleziono: true});
                    this.ustawDoEdycji(response.data, true)
                    alert('Znaleziono firmę po numerze NIP i uzupełniono dane')
                } else {
                    this.setState({czyKliknietoWyszukaj: true, czyZnaleziono: false})
                    alert('Nie znaleziono firmy po numerze NIP')
                }
            }.bind(this))
        } else {
            alert('Proszę podać poprawny numer NIP (10 znaków)')
        }
    }

    render() {
        return <div>
            <hr/>
            <div
                className={'fieldset-label text-center'}>
                <h5>{Boolean(this.props.edytowanaFirma) && (this.props.nowaFirma !== 1) ? 'Edycja firmy' : 'Nowa firma'}</h5></div>
            <Form horizontal={true}>
                <FormGroup style={{marginBottom: 0}}>
                    <div className="row">
                        <div className="col-lg-12">
                            <ControlLabel>
                                NIP<span className={'req'}>*</span>:
                            </ControlLabel>
                            <div className="row">
                                <div className="col-lg-8">
                                    <FormControl id={'inputNip'} type={'number'}
                                                 onChange={(e) => this.onChangeWartosc(e, 'nip')}
                                                 disabled={Boolean(this.props.edytowanaFirma)}/>
                                </div>
                                <div className="col-lg-4">
                                    <Button bsStyle={'success'} onClick={this.onClickWyszukaj}>Szukaj</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: 16}}>
                        <div className="col-lg-6">
                            <ControlLabel>
                                Nazwa<span className={'req'}>*</span>:
                            </ControlLabel>
                            <FormControl id={'inputNazwa'} onChange={(e) => this.onChangeWartosc(e, 'nazwa')}/>
                        </div>
                        <div className="col-lg-6">
                            <ControlLabel>
                                REGON:
                            </ControlLabel>
                            <FormControl id={'inputRegon'} type={'number'}
                                         onChange={(e) => this.onChangeWartosc(e, 'regon')}/>
                        </div>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div className="row" style={{marginTop: 16}}>
                        <div className="col-lg-6">
                            <ControlLabel>
                                Forma prawna:
                            </ControlLabel>
                            <FormControl id={'inputformaPrawna'}
                                         onChange={(e) => this.onChangeWartosc(e, 'formaPrawna')}/>
                        </div>
                        <div className="col-lg-6">
                            <ControlLabel>
                                Forma szczegółowa nazwa:
                            </ControlLabel>
                            <FormControl id={'inputformaSzczegolowaNazwa'}
                                         onChange={(e) => this.onChangeWartosc(e, 'formaSzczegolowaNazwa')}/>
                        </div>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div className="row">
                        <div className="col-lg-4">
                            <ControlLabel>
                                Miejscowość<span className={'req'}>*</span>:
                            </ControlLabel>
                            <FormControl id={'inputMiejscowosc'}
                                         onChange={(e) => this.onChangeWartosc(e, 'miejscowosc')}/>
                        </div>
                        <div className="col-lg-4">
                            <ControlLabel>
                                Ulica:
                            </ControlLabel>
                            <FormControl id={'inputUlica'} onChange={(e) => this.onChangeWartosc(e, 'ulica')}/>
                        </div>
                        <div className="col-lg-4">
                            <ControlLabel>
                                Budynek / lokal:
                            </ControlLabel>
                            <div className="row">
                                <div className="col-lg-6">
                                    <FormControl id={'inputNrNieruchomosci'}
                                                 onChange={(e) => this.onChangeWartosc(e, 'budynek')}/>
                                </div>
                                <div className="col-lg-6">
                                    <FormControl id={'inputNrLokalu'}
                                                 onChange={(e) => this.onChangeWartosc(e, 'lokal')}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </FormGroup>
                <FormGroup>
                    <div className="row">
                        <div className="col-lg-2">
                            <ControlLabel>
                                Kod pocztowy:
                            </ControlLabel>
                            <FormControl id={'inputKodPocztowy'}
                                         onChange={(e) => this.onChangeWartosc(e, 'kodPocztowy')}/>
                        </div>
                        <div className="col-lg-5">
                            <ControlLabel>
                                Poczta:
                            </ControlLabel>
                            <FormControl id={'inputPoczta'} onChange={(e) => this.onChangeWartosc(e, 'poczta')}/>
                        </div>
                        <div className="col-lg-2">
                            <ControlLabel>
                                Województwo:
                            </ControlLabel>
                            <FormControl id={'inputWojewodztwo'}
                                         onChange={(e) => this.onChangeWartosc(e, 'wojewodztwo')}/>
                        </div>
                        <div className="col-lg-3">
                            <ControlLabel>
                                Powiat:
                            </ControlLabel>
                            <FormControl id={'inputPowiat'} onChange={(e) => this.onChangeWartosc(e, 'powiat')}/>
                        </div>
                    </div>
                    <div className="row" style={{marginTop: 16}}>
                        <div className="col-lg-4">
                            <ControlLabel>
                                Gmina:
                            </ControlLabel>
                            <FormControl id={'inputGmina'} onChange={(e) => this.onChangeWartosc(e, 'gmina')}/>
                        </div>
                        <div className="col-lg-8 text-right" style={{marginTop: 32}}>

                            <Button bsStyle={'danger'} onClick={() => {
                                this.props.handleClickAnuluj()
                            }}>Anuluj</Button>
                            <Button bsStyle={'success'} style={{marginLeft: 5}}
                                    onClick={this.onClickZapisz}>Zapisz</Button>
                        </div>
                    </div>
                </FormGroup>
            </Form>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/FirmyFormComponent.js